import React from 'react';
import { MODAL_TYPES } from '@components/modals';
import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useModal } from '@store/hooks';

import CalendarSettingsMenu from './CalendarSettingsMenu';
import { MiniCalendar } from './MiniCalendar';
import { ScheduleViewToggle } from './ScheduleViewToggle';
import SyncGoogleCalendar from './SyncGoogleCalendar';
import { ViewModeSelector } from './ViewModeSelector';

/**
 * CalendarSidebar - Container component for sidebar content in the calendar view
 * Includes MiniCalendar and can be extended with additional sidebar features
 */
export const CalendarSidebar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const modal = useModal();

  const handleOpenManagementModal = () => {
    modal.open(MODAL_TYPES.APPOINTMENT_TYPES_MANAGEMENT);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        gap: 3,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Mini Calendar */}
        <MiniCalendar />

        {/* Schedule View Toggle - only on mobile */}
        {isMobile && (
          <Box sx={{ pl: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <ViewModeSelector variant="dropdown" />
            <ScheduleViewToggle />
          </Box>
        )}

        {/* Appointment Types Section */}
        <Box sx={{ pl: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: '15px',
                fontWeight: 400,
                color: '#535976',
              }}
            >
              Appointment Types
            </Typography>
            <IconButton
              onClick={handleOpenManagementModal}
              sx={{
                backgroundColor: 'white',
                '&:hover': { backgroundColor: 'white' },
                width: 24,
                height: 24,
              }}
              aria-label="Manage Appointment Types"
            >
              <AddIcon sx={{ color: 'primary.main', fontSize: 20 }} />
            </IconButton>
          </Box>
        </Box>
      </Box>

      {/* Settings and Sync - only on mobile, at the bottom */}
      {isMobile && (
        <Box sx={{ pb: 12 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              pl: 2,
            }}
          >
            <CalendarSettingsMenu variant="fullWidth" />
            <SyncGoogleCalendar variant="fullWidth" />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CalendarSidebar;
